var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush } from "../shared/utils";
var ghfEventsHandler = function (e) {
    var baseResetData = {
        screen_name: "",
        non_interaction: false,
    };
    var ghfEventData = e && e.detail
        && Object.assign({}, baseResetData, normalizeObject(e.detail));
    var eventKey = e === null || e === void 0 ? void 0 : e.type;
    if (eventKey === "ghf_navigation") {
        dataLayerPush(__assign(__assign({}, ghfEventData), { event: "menu_navigation", event_category: "navigation" }));
    }
    if (eventKey === "cart_set") {
        dataLayerPush(__assign(__assign({}, ghfEventData), { event: "cart_set", non_interaction: true }));
    }
};
export { ghfEventsHandler };
